<template>
<div class="element-btn" @click.exact="buttonClicked">
    <div :title="(element.width == 10 ? text : '')">
        <v-icon :color="(element.complete || complete ? 'primary': 'grey')" style="font-size:24px">{{icon || 'category'}}</v-icon>
    </div>
    <div v-if="element.width != 10" style="margin-left:8px">
        {{text || element.title}}
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
        
        }
    },
    
    props: {
        icon: String,
        text: String,
        element: Object,
        complete: Boolean,

    },

    computed: {
        attributes() {

        }
    },

    methods: {
        buttonClicked() {
            this.$emit('click')
        }

    }
}
</script>

<style scoped>
.element-btn {
    width:auto;
    display:flex;
    padding: 6px 10px;
    margin-left:-10px; margin-top:14px;
    border: solid 1px transparent;
    border-radius: 5px;
    color: #555;
    font-size:16px;
}
.element-btn:hover {
    border-color:#ccc;
    background-color: #f0f0f0;
}
   
</style>




// WEBPACK FOOTER //
// ElementButton.vue?04f23810